<div *ngIf='screenWidth > 767'>
  <div class="flex"></div>
  <div class="flex-444-px">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Devices</div>
      <div>See what devices have accessed your account in the last 30 days.</div>
      <div class="bmw-manage-devices">
        <div *ngFor='let deviceInfo of userDevicesInfo' class="bmw-device-info flex-container row">
          <div class="flex-12" class="bmw-user-device-icon">
            <i class="material-icons">
              {{ deviceInfo?.deviceType === 'Mobile' ? 'phone_iphone' : deviceInfo?.deviceType === 'Tablet' ? 'tablet_mac' : deviceInfo?.deviceType
              === 'Desktop' ? 'desktop_windows' : 'laptop_mac' }}
            </i>
          </div>
          <div class="bmw-user-device-title flex">
            {{deviceInfo ? deviceInfo?.firstName+"'s "+deviceInfo?.deviceType : ''}}
          </div>
          <div class="flex">
            <div class="bmw-user-device-accessed-date">
              {{deviceInfo?.loginDate}}
            </div>
          </div>
        </div>
      </div>
      <div>Notice something wrong?</div>
      <div [routerLink]='["/manage-profile", "change-password"]' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-devices-navigate-links pointer">
        Change your password
      </div>
      <div [routerLink]='["/manage-profile", "account-recovery"]' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-devices-navigate-links pointer">
        Check your account recovery info
      </div>
      <div [routerLink]='["/manage-profile", "companion"]' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-devices-navigate-links pointer">
        Check your companion account
      </div>
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div class="bmw-profile-content bmw-xs">
      <div class="bmw-user-info-title">Devices</div>
      <div>See what devices have accessed your account in the last 30 days.</div>
      <div class="bmw-manage-devices">
        <div *ngFor='let deviceInfo of userDevicesInfo' class="bmw-device-info flex-container row">
          <div class="bmw-user-device-icon flex-12">
            <i class="material-icons">
              {{ deviceInfo?.deviceType === 'Mobile' ? 'phone_iphone' : deviceInfo?.deviceType === 'Tablet' ? 'tablet_mac' : deviceInfo?.deviceType
              === 'Desktop' ? 'desktop_windows' : 'laptop_mac' }}
            </i>
          </div>
          <div class="bmw-user-device-title flex">
            {{deviceInfo ? deviceInfo?.firstName+"'s "+deviceInfo?.deviceType : ''}}
          </div>
          <div class="flex">
            <div class="bmw-user-device-accessed-date">
              {{deviceInfo?.loginDate}}
            </div>
          </div>
        </div>
      </div>
      <div>Notice something wrong?</div>
      <div [routerLink]='["/manage-profile", "change-password"]' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-devices-navigate-links pointer">
        Change your password
      </div>
      <div [routerLink]='["/manage-profile", "account-recovery"]' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-devices-navigate-links pointer">
        Check your account recovery info
      </div>
      <div [routerLink]='["/manage-profile", "companion"]' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-devices-navigate-links pointer">
        Check your companion account
      </div>
      <div [routerLink]='["/profile"]' class="bmw-button-secondary bmw-xs pointer" >Back</div>
    </div>
  </div>
</div>